import React, { useState, useEffect } from 'react';

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import jwt from 'jsonwebtoken'
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';


import { BaseURL, loginApi, MasterKeyLogin } from '../constants/constants'
import { useHistory, useLocation } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Buttons from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CryptoJS from 'crypto-js'
import superagent from 'superagent'
import { useMediaQuery } from 'react-responsive'
import MailIcon from '@material-ui/icons/MailOutline';
import PersonOutlineRoundedIcon from '@material-ui/icons/PersonOutlineRounded';
import InputAdornment from '@material-ui/core/InputAdornment';
import axios from 'axios'
import bgDash from '../assets/portada.png';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import SecurityIcon from '@material-ui/icons/Security';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

function Copyright() {
  const classes = useStyles();
  return (
    <Typography variant="body2" color="textSecondary" align="center" className={classes.copyright}  > {'Copyright © R4. Banco Microfinanciero ' + new Date().getFullYear() + '. J-31594102-3'} {'.'}</Typography>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${bgDash})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  },
  cintillo: {
    width: "100%",
    height: 17,
    backgroundImage: "linear-gradient(to right, #E9540D, #6730E3, rgba(83, 49, 177, 1))",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: theme.zIndex.drawer + 2,
  },
  paper2: {
    margin: theme.spacing(25, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    color: "white"
  },
  paper: {
    [theme.breakpoints.only('xl')]: {
      margin: theme.spacing(26, 16),
    },
    margin: theme.spacing(18, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative', // Para posicionar el botón de regreso
  },
  inputText: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#E9540D',
      },
      '&:hover fieldset': {
        borderColor: '#E9540D',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#E9540D',
      },
    },
  },
  title: {
    fontWeight: "bolder",
    marginLeft: "15%"
  },
  paragraph: {
    marginTop: '30px',
    marginLeft: '15%',
    marginRight: '15%',
    fontWeight: '400'
  },
  gridLogin: {
    backgroundColor: "#f4f7fa"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#6730e3",
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(5),
  },
  subtitleLogin: {
    marginTop: '5px',
    color: "#707070"
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#E9540D",
    borderRadius: 5,
    '&:hover': {
      backgroundColor: "gray",
    },
  },
  buttonProgress: {
    color: "#6730e3",
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  iconmail: {
    color: "#E9540D"
  },
  iconValid: {
    color: "#4CAF50" // Verde para cuando es válido
  },
  inputLabel: {
    color: '#E9540D',
    '&.Mui-focused': {
      color: '#E9540D',
    },
  },
  copyright: {
    [theme.breakpoints.only('md')]: {
      fontSize: '10px',
    },
  },
  // Nuevo estilo para el botón de visibilidad
  visibilityButton: {
    color: '#E9540D',
    '&:hover': {
      backgroundColor: 'rgba(233, 84, 13, 0.1)',
    },
  },

  forgotPassword: {
    color: '#E9540D',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  // Estilo para el botón de regreso
  backButton: {
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
    color: '#E9540D',
    '&:hover': {
      backgroundColor: 'rgba(233, 84, 13, 0.1)',
    },
  },
  // Estilo para mensajes de error de validación
  errorText: {
    color: '#f44336',
    fontSize: '0.75rem',
    marginTop: '3px',
  },
}));


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


export default function SignInSide(props) {
  const classes = useStyles();
  let history = useHistory();
  let location = useLocation();
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)'
  })
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatNewPassword, setRepeatNewPassword] = useState("");
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false)
  const [emptyMail, setEmptyMail] = useState(false)
  const [emptyCorreo, setEmptyCorreo] = useState(false)
  const [emptyPassword, setEmptyPassword] = useState(false)
  const [emptyNewPassword, setEmptyNewPassword] = useState(false)
  const [emptyRepeatNewPassword, setEmptyRepeatNewPassword] = useState(false)
  const [emptyCodigo, setEmptyCodigo] = useState(false)
  const [equalsPassword, setEqualsPassword] = useState(true)
  const [rif, setRif] = useState("")
  const [first_time, setFirst_time] = useState(false)

  const [forgotPassword, setForgotPassword] = useState(false);
  const [context, setContext] = useState("login"); // Estado para controlar el contexto del formulario
  const [correo, setCorreo] = useState("");
  const [razonSocial, setRazonSocial] = useState("");
  const [code, setCode] = useState("");

  // Nuevo estado para controlar la visibilidad de la contraseña
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRepeatNewPassword, setShowRepeatNewPassword] = useState(false);
  const [dialogMsg, setDialogMsg] = useState("")

  // Estados para las validaciones de contraseña
  const [passwordErrors, setPasswordErrors] = useState({
    minLength: false,
    maxLength: false,
    alphanumeric: false,
    specialChar: false,
    number: false,
    consecutiveChars: false,
    containsR4: false,
    containsCompanyName: false // Nueva validación
  });

  // Estado para saber si la contraseña es válida
  const [isPasswordValid, setIsPasswordValid] = useState(false);

  if (localStorage.getItem(process.env.REACT_APP_KEY_RIF) != null || sessionStorage.getItem(process.env.REACT_APP_KEY_RIF) && !first_time) {

    history.push('/home');
  }

  // Función para validar si la contraseña contiene palabras del nombre de la empresa
  const validateCompanyNameInPassword = (password, companyName) => {
    if (!companyName || companyName.trim() === '' || !password) return false;

    const passwordClean = password.toLowerCase().replace(/[^a-z0-9]/g, '');
    const companyNameLower = companyName.toLowerCase();

    // Dividir en palabras y filtrar palabras de 3+ caracteres
    const words = companyNameLower.split(/\s+/).filter(word => word.length >= 3);

    // Verificar si alguna palabra está contenida en la contraseña (limpia de caracteres especiales)
    for (const word of words) {
      if (passwordClean.includes(word)) {
        return true;
      }
    }

    return false;
  };

  // Función para validar la contraseña
  const validatePassword = (password) => {
    const containsCompanyName = razonSocial ? validateCompanyNameInPassword(password, razonSocial) : false;

    const errors = {
      minLength: password.length < 8,
      maxLength: password.length > 15,
      alphanumeric: !/^[a-zA-Z0-9!@#$%&*]+$/.test(password),
      specialChar: (password.match(/[!@#$%&*]/g) || []).length !== 1,
      number: (password.match(/[0-9]/g) || []).length !== 1,
      consecutiveChars: /(.)\1\1/.test(password),
      containsR4: /r4/i.test(password),
      containsCompanyName: containsCompanyName
    };

    setPasswordErrors(errors);
    const isValid = !Object.values(errors).some(error => error);
    setIsPasswordValid(isValid);
    return isValid;
  };

  // Función para obtener el texto de ayuda con los errores
  const getPasswordHelperText = () => {
    if (emptyNewPassword) {
      return "Campo vacío";
    }

    const errors = [];
    if (passwordErrors.minLength) errors.push("Mínimo 8 caracteres");
    if (passwordErrors.maxLength) errors.push("Máximo 15 caracteres");
    if (passwordErrors.alphanumeric) errors.push("Solo caracteres alfanuméricos y !@#$%&*");
    if (passwordErrors.specialChar) errors.push("Exactamente 1 carácter especial (!@#$%&*)");
    if (passwordErrors.number) errors.push("Exactamente 1 número");
    if (passwordErrors.consecutiveChars) errors.push("No más de 2 caracteres consecutivos iguales");
    if (passwordErrors.containsR4) errors.push("No debe contener el nombre del banco");
    if (passwordErrors.containsCompanyName) {
      // Encontrar qué palabra del nombre de la empresa está en la contraseña
      let problematicWord = "";
      if (razonSocial && newPassword) {
        const passwordClean = newPassword.toLowerCase().replace(/[^a-z0-9]/g, '');
        const words = razonSocial.toLowerCase().split(/\s+/).filter(word => word.length >= 3);
        problematicWord = words.find(word => passwordClean.includes(word)) || "";
      }
      errors.push(`No debe contener el nombre de la empresa${problematicWord ? ` (ej: "${problematicWord}")` : ''}`);
    }

    return errors.length > 0 ? errors.join(", ") : "";
  };

  // Función para verificar si hay errores de validación
  const hasPasswordErrors = () => {
    return Object.values(passwordErrors).some(error => error);
  };

  // Función para obtener el color del icono del candado
  const getLockIconColor = () => {
    return isPasswordValid ? classes.iconValid : classes.iconmail;
  };

  // Función para manejar el retroceso
  const handleBack = () => {
    if (forgotPassword) {
      if (context === "resetPassword") {
        setContext("mail");
      } else {
        setForgotPassword(false);
        setContext("login");
      }
    } else if (first_time) {
      setFirst_time(false);
    }
  };

  const loginUser = async (req) => {
    try {
      var apiBaseUrl = BaseURL;
      var payload = {
        "Username": req.user,
        "Clave": req.password
      }

      let result = await axios.post(apiBaseUrl + loginApi, payload)

      if (result.data.exito) {
        let id = result.data.data_usuario.id_usuario
        let id_commerce = result.data.data_usuario.identificador_comercio
        let idEmpresa = result.data.data_usuario.id_empresa
        let usuario = result.data.data_usuario.nombre_usuario
        let rif = result.data.data_usuario.rif
        let razon_social = result.data.data_usuario.razon_social
        let url_image = result.data.data_usuario.url_image
        let token = result.data.token
        var cryptorif = CryptoJS.AES.encrypt(rif, MasterKeyLogin);
        var cryptoid = CryptoJS.AES.encrypt(id.toString(), MasterKeyLogin);
        var cryptorazon = CryptoJS.AES.encrypt(razon_social.toString(), MasterKeyLogin);
        var cryptoimage
        var cryptousername = CryptoJS.AES.encrypt(usuario.toString(), MasterKeyLogin);
        let cryptoidEmpresa = CryptoJS.AES.encrypt(idEmpresa.toString(), MasterKeyLogin);
        let cryptoidCommerce = id_commerce;

        // Manejo de la imagen
        if (url_image === null || url_image === undefined) {
          cryptoimage = null;
          sessionStorage.setItem(process.env.REACT_APP_KEY_IMAGE, cryptoimage);
        } else {
          cryptoimage = CryptoJS.AES.encrypt(url_image.toString(), MasterKeyLogin);
          sessionStorage.setItem(process.env.REACT_APP_KEY_IMAGE, cryptoimage.toString());
        }

        // Persistencia del resto de los datos
        sessionStorage.setItem(process.env.REACT_APP_KEY_RIF, cryptorif.toString());
        sessionStorage.setItem(process.env.REACT_APP_KEY_USUARIO, cryptoid.toString());
        sessionStorage.setItem(process.env.REACT_APP_KEY_RAZON, cryptorazon.toString());
        sessionStorage.setItem(process.env.REACT_APP_KEY_TOKEN, token.toString());
        sessionStorage.setItem(process.env.REACT_APP_KEY_NOMBRE_USUARIO, cryptousername);
        sessionStorage.setItem(process.env.REACT_APP_KEY_EMPRESA, cryptoidEmpresa.toString());
        sessionStorage.setItem(process.env.REACT_APP_KEY_COMMERCE, cryptoidCommerce.toString());
        return true
      } else {
        handleClickOpen(result.data.message)
        return false
      }

    } catch (error) {

    }
  }

  function handleClick(event) {
    event.preventDefault()
    var ismailEmpty = isEmpty(email, "mail")
    var isPassEmpty = isEmpty(password, "password")

    if (ismailEmpty || isPassEmpty) {
      return
    }
    var ciphertext = CryptoJS.AES.encrypt(email, MasterKeyLogin);
    var cipherpass = CryptoJS.AES.encrypt(password, MasterKeyLogin);
    var apiBaseUrl = BaseURL;
    var payload = {
      "Username": ciphertext.toString(),
      "Clave": cipherpass.toString()
    }
    setLoader(true)

    superagent
      .post(apiBaseUrl + loginApi)
      .send(payload)
      .then(response => {
        setLoader(false)

        if (response.body.exito) {
          if (response.body.data_usuario.first_time) {
            setFirst_time(true)
            setRif(response.body.data_usuario.rif)
            setRazonSocial(response.body.data_usuario.razon_social) // Establecer razón social
            return
          } else {
            let id_commerce = response.body.data_usuario.identificador_comercio
            let id = response.body.data_usuario.id_usuario
            let idEmpresa = response.body.data_usuario.id_empresa
            let usuario = response.body.data_usuario.nombre_usuario
            let rif = response.body.data_usuario.rif
            let razon_social = response.body.data_usuario.razon_social
            let url_image = response.body.data_usuario.url_image
            let token = response.body.token
            var cryptorif = CryptoJS.AES.encrypt(rif, MasterKeyLogin);
            var cryptoid = CryptoJS.AES.encrypt(id.toString(), MasterKeyLogin);
            var cryptorazon = CryptoJS.AES.encrypt(razon_social.toString(), MasterKeyLogin);
            var cryptoimage

            var cryptousername = CryptoJS.AES.encrypt(usuario.toString(), MasterKeyLogin);
            let cryptoidEmpresa = CryptoJS.AES.encrypt(idEmpresa.toString(), MasterKeyLogin);
            let cryptoidCommerce = id_commerce;
            if (url_image === null || url_image === undefined) {
              cryptoimage = null
              sessionStorage.setItem("_{}4RThhUJHHUKNMJKK", cryptoimage)
            } else {
              cryptoimage = CryptoJS.AES.encrypt(url_image.toString(), MasterKeyLogin);
              sessionStorage.setItem("_{}4RThhUJHHUKNMJKK", cryptoimage.toString())
            }

            sessionStorage.setItem("_CDAUPOMGKLJL", cryptorif.toString())
            sessionStorage.setItem("_CDAUPOMGKLJLTYJIKH", cryptoid.toString())
            sessionStorage.setItem("_CDAUPOMGKLJLTYJIKHhkuiok", cryptorazon.toString())
            sessionStorage.setItem("_{}KRTKLMNHFGFBJNMKKDKDDM", token.toString())
            sessionStorage.setItem("_{}KRTKLMNHFGFBJNMKKDKDDMUSR", cryptousername)
            sessionStorage.setItem("_{}KRTKLMNHFGFBJNMKKDKDDMEMP", cryptoidEmpresa.toString())
            sessionStorage.setItem("_{}KRTKLMNHFGFBJNMKKDKDDMCOM", cryptoidCommerce.toString())


            history.push('/home');

          }
        }
        else {
          handleClickOpen(response.body.message)

        }
      })
      .catch(error => {
        setLoader(false)

        alert(error)
      })
  }

  function handleClickNewPassword(event) {
    event.preventDefault()
    let isPassEmpty = isEmptyNewPass(newPassword, "newpassword")
    let isRepeatPassEmpty = isEmptyNewPass(repeatNewPassword, "repeatNewPassword")
    if (isPassEmpty || isRepeatPassEmpty) {
      return
    }

    // Validar la contraseña antes de proceder
    if (!validatePassword(newPassword)) {
      return;
    }

    if (newPassword !== repeatNewPassword) {
      setEqualsPassword(false)
      return
    } else {
      setEqualsPassword(true)
    }

    setLoader(true)
    let ciphernewpassword = CryptoJS.AES.encrypt(newPassword, process.env.REACT_APP_LOGIN_KEY);
    let cipherpassword = CryptoJS.AES.encrypt(password, process.env.REACT_APP_LOGIN_KEY);

    let payload = {
      username: email,
      rif: rif,
      password: cipherpassword.toString(),
      new_password: ciphernewpassword.toString(),

    }
    axios.put(process.env.REACT_APP_URL + process.env.REACT_APP_NEW_PASSWORD, payload)
      .then(function (response) {

        setLoader(false)
        if (response.data.exito) {
          //setMsgs(response.data.Message)
          let cipherUser = CryptoJS.AES.encrypt(email, process.env.REACT_APP_LOGIN_KEY);
          loginUser({ user: cipherUser.toString(), password: ciphernewpassword.toString() })
            .then((res) => {
              if (res) {
                history.push('/home');
              }
            })


        }
        else {
          //setMsgs(response.data.Message)
          //handleClickOpen()
        }

      })
      .catch(function (error) {
        setLoader(false)

        // setMsgs("Error en el servidor")
      });
    //  

  }

  async function handleClickUpdatePassword(event) {  // conectar con backend para actualizar contraseña
    event.preventDefault()
    setLoader(true)
    try {


      let isPassEmpty = isEmptyNewPass(newPassword, "newpassword")
      let isRepeatPassEmpty = isEmptyNewPass(repeatNewPassword, "repeatNewPassword")
      let isCodeEmpty = isEmptyCode(code)


      if (isPassEmpty || isRepeatPassEmpty || isCodeEmpty) {
        setLoader(false)
        return
      }

      // Validar la contraseña antes de proceder
      if (!validatePassword(newPassword)) {
        setLoader(false);
        return;
      }

      if (newPassword !== repeatNewPassword) {
        setEqualsPassword(false)
        setLoader(false)
        return
      } else {
        setEqualsPassword(true)
      }

      let payload = {
        username: CryptoJS.AES.encrypt(correo, process.env.REACT_APP_LOGIN_KEY).toString(),
        code: CryptoJS.AES.encrypt(code, process.env.REACT_APP_LOGIN_KEY).toString(),
        password: CryptoJS.AES.encrypt(newPassword, process.env.REACT_APP_LOGIN_KEY).toString()
      }

      let result = await axios.put(process.env.REACT_APP_URL + process.env.REACT_APP_UPDATE_PASSWORD, payload)

      if (result.data.exito) {
        setLoader(false)


        loginUser({ user: payload.username, password: payload.password })
          .then((res) => {
            if (res) {
              history.push('/home');
            }
          })
      } else {
        setLoader(false)
        handleClickOpen(result.data.message)
      }


    } catch (error) {

      setLoader(false)
      handleClickOpen(error.message)

    }
  }

  async function handleClickValidateUserName(event) {
    event.preventDefault()
    setLoader(true)
    try {

      var ismailEmpty = await isEmptyMailRecover(correo)

      if (ismailEmpty) {
        setLoader(false)
        return
      }

      let payload = {
        Username: CryptoJS.AES.encrypt(correo, process.env.REACT_APP_LOGIN_KEY).toString()
      }

      let result = await axios.post(process.env.REACT_APP_URL + process.env.REACT_APP_FORGOT_PASSWORD, payload)


      if (result.data.exito) {
        setLoader(false)
        setContext("resetPassword")
        setRazonSocial(result.data.razon_social) // Establecer razón social desde la respuesta
      } else {
        setLoader(false)
        handleClickOpen("Usuario no encontrado")
      }

    } catch (error) {
      handleClickOpen("Error del sistema : 509")
      setLoader(false)
    }

  }

  // Función para manejar el cambio en el campo de nueva contraseña
  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    validatePassword(value);
  };

  function isEmpty(field, type) {
    // Uso de validateNotEmpty para simplificar la verificación
    const empty = validateNotEmpty(field);
    if (type === "mail") {
      setEmptyMail(empty);
    } else if (type === "password") {
      setEmptyPassword(empty);
    }
    return empty;
  }

  function isEmptyNewPass(field, type) {
    const empty = validateNotEmpty(field);
    if (type === "newpassword") {
      setEmptyNewPassword(empty);
    }
    if (type === "repeatNewPassword") {
      setEmptyRepeatNewPassword(empty);
    }
    return empty;
  }

  function isEmptyMailRecover(field) {
    // Uso de validateNotEmpty para simplificar la verificación
    const empty = validateNotEmpty(field);
    
    setEmptyCorreo(empty);

    return empty;
  }

  function isEmptyCode(field) {
    // Uso de validateNotEmpty para simplificar la verificación
    const empty = validateNotEmpty(field);

    setEmptyCodigo(empty);

    return empty;
  }

  // Valida que un campo no esté vacío (strings vacíos o solo espacios cuentan como vacío)
  function validateNotEmpty(field) {
    if (field === null || field === undefined) return true;
    if (typeof field === 'string') {
      return field.trim() === '';
    }
    // Para otros tipos (por ejemplo arrays) considerar vacío si no tiene longitud
    if (Array.isArray(field)) return field.length === 0;
    return false;
  }

  const handleClickOpen = (msg) => {
    setDialogMsg(msg)
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Función para alternar la visibilidad de la contraseña
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // Función para alternar la visibilidad de la nueva contraseña
  const handleClickShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  // Función para alternar la visibilidad de repetir nueva contraseña
  const handleClickShowRepeatNewPassword = () => {
    setShowRepeatNewPassword(!showRepeatNewPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{"Error"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {dialogMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Buttons onClick={handleClose} color="primary">
            Ok
          </Buttons>
        </DialogActions>
      </Dialog>

      <Grid container component="main" className={classes.root} >
        <CssBaseline />
        <div className={classes.cintillo}></div>
        <Grid item xs={false} sm={4} md={7} lg={8} xl={8} className={classes.image} />
        <Grid className={classes.gridLogin} item xs={12} sm={8} md={5} lg={4} xl={4} component={Paper} elevation={6} square>

          <div className={classes.paper}>
            {/* Botón de regreso - solo se muestra en ciertos estados */}
            {(forgotPassword || first_time) && (
              <IconButton
                onClick={handleBack}
                className={classes.backButton}
              >
                <ArrowBackIcon />
              </IconButton>
            )}

            <img src={require("../assets/plinklogo.png")} alt="Plink Logo" style={{ width: '50%', height: 'auto', display: 'block', margin: 'auto' }} />
            {!first_time && !forgotPassword && context === "login" && <form className={classes.form} >
              <TextField
                error={emptyMail}
                className={classes.inputText}
                variant="outlined"
                margin="normal"
                color="#6730e3"
                required
                fullWidth
                id="email"
                label="Usuario"
                name="email"
                onChange={e => setEmail(e.target.value)}
                disabled={loader}
                autoFocus
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutlineRoundedIcon className={classes.iconmail} />
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.inputLabel,
                    focused: classes.inputLabelFocused,
                  }
                }}
                helperText={emptyMail ? "Campo vacio" : ""}
              />

              {/* Campo de contraseña con ojito */}
              <TextField
                className={classes.inputText}
                error={emptyPassword}
                variant="outlined"
                margin="normal"
                color="#E9540D"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type={showPassword ? 'text' : 'password'}
                id="password"
                disabled={loader}
                onChange={e => setPassword(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockOutlinedIcon className={classes.iconmail} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        className={classes.visibilityButton}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.inputLabel,
                    focused: classes.inputLabelFocused,
                  }
                }}
                helperText={emptyPassword ? "Campo vacio" : ""}
              />

              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={loader}
                onClick={(event) => handleClick(event)}
              >
                {loader && <CircularProgress size={24} className={classes.buttonProgress} />}
                Iniciar sesión
              </Button>

              <Grid container justifyContent="flex-end">
                <Grid item>
                  <Link
                    href="#"
                    variant="body2"
                    className={classes.forgotPassword}
                    onClick={(e) => {
                      e.preventDefault();
                      setForgotPassword(true);
                      setContext("mail");
                    }}
                  >
                    ¿Olvidó su contraseña?
                  </Link>
                </Grid>
              </Grid>
              <Box mt={5}>
                <Copyright />
              </Box>
            </form>}
            {
              !first_time && forgotPassword && context === "mail" &&
              <form className={classes.form} >
                <TextField
                  error={emptyCorreo}
                  className={classes.inputText}
                  variant="outlined"
                  margin="normal"
                  color="#E9540D"
                  required
                  fullWidth
                  id="correo"
                  label="Usuario Plink"
                  type='text'
                  name="correo"
                  onChange={e => setCorreo(e.target.value)}
                  disabled={loader}
                  autoFocus
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonOutlineRoundedIcon className={classes.iconmail} />
                      </InputAdornment>
                    )
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.inputLabel,
                      focused: classes.inputLabelFocused,
                    }
                  }}
                  helperText={emptyCorreo && "Campo vacio"}
                />



                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  disabled={loader}
                  onClick={(event) => handleClickValidateUserName(event)}
                >
                  {loader && <CircularProgress size={24} className={classes.buttonProgress} />}
                  Enviar
                </Button>

                <Box mt={5}>
                  <Copyright />
                </Box>
              </form>

            }

            {

              !first_time && forgotPassword && context === "resetPassword" &&
              <form className={classes.form} >
                <TextField
                  error={emptyCodigo}
                  className={classes.inputText}
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="code"
                  label="Código de Seguridad"
                  value={code}
                  onChange={e => {
                    const numericValue = e.target.value.replace(/[^0-9]/g, '').slice(0, 7);
                    setCode(numericValue);
                  }}
                  helperText={emptyCodigo ? "Campo vacío" : ""}
                  inputMode="numeric"
                  disabled={loader}
                  autoFocus
                  autoComplete="off"
                  inputProps={{
                    maxLength: 7,
                    pattern: "[0-9]*",
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SecurityIcon className={classes.iconmail} />
                      </InputAdornment>
                    ),
                    autoComplete: "off"
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.inputLabel,
                      focused: classes.inputLabelFocused,
                    }
                  }}
                />

                <TextField
                  error={emptyNewPassword || !equalsPassword || hasPasswordErrors()}
                  className={classes.inputText}
                  variant="outlined"
                  margin="normal"
                  color="#E9540D"
                  required
                  fullWidth
                  id="newPassword"
                  label="Nueva Contraseña"
                  type={showNewPassword ? 'text' : 'password'}
                  name="newPassword"
                  value={newPassword}
                  onChange={handleNewPasswordChange}
                  disabled={loader}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockOutlinedIcon className={getLockIconColor()} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle new password visibility"
                          onClick={handleClickShowNewPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          className={classes.visibilityButton}
                        >
                          {showNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.inputLabel,
                      focused: classes.inputLabelFocused,
                    }
                  }}
                  helperText={getPasswordHelperText()}
                />

                <TextField
                  className={classes.inputText}
                  error={emptyRepeatNewPassword || !equalsPassword}
                  variant="outlined"
                  margin="normal"
                  color="#E9540D"
                  required
                  fullWidth
                  type={showRepeatNewPassword ? 'text' : 'password'}
                  name="repeatpassword"
                  label="Repetir Nueva Contraseña"
                  id="repeatpassword"
                  disabled={loader}
                  onChange={e => setRepeatNewPassword(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockOutlinedIcon className={classes.iconmail} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle repeat password visibility"
                          onClick={handleClickShowRepeatNewPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          className={classes.visibilityButton}
                        >
                          {showRepeatNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )

                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.inputLabel,
                      focused: classes.inputLabelFocused,
                    }
                  }}
                  helperText={emptyRepeatNewPassword ? "Campo vacio" : !equalsPassword ? "Las contraseñas no coinciden" : ""}
                />

                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  disabled={loader}
                  onClick={(event) => handleClickUpdatePassword(event)}
                >
                  {loader && <CircularProgress size={24} className={classes.buttonProgress} />}
                  Conectar
                </Button>

                <Box mt={5}>
                  <Copyright />
                </Box>
              </form>

            }


            {first_time &&
              <form className={classes.form} >
                <TextField
                  error={emptyNewPassword || !equalsPassword || hasPasswordErrors()}
                  className={classes.inputText}
                  variant="outlined"
                  margin="normal"
                  color="#E9540D"
                  required
                  fullWidth
                  id="newPassword"
                  label="Nueva Contraseña"
                  type={showNewPassword ? 'text' : 'password'}
                  name="newPassword"
                  value={newPassword}
                  onChange={handleNewPasswordChange}
                  disabled={loader}
                  autoFocus
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockOutlinedIcon className={getLockIconColor()} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle new password visibility"
                          onClick={handleClickShowNewPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          className={classes.visibilityButton}
                        >
                          {showNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.inputLabel,
                      focused: classes.inputLabelFocused,
                    }
                  }}
                  helperText={getPasswordHelperText()}
                />

                <TextField
                  className={classes.inputText}
                  error={emptyRepeatNewPassword || !equalsPassword}
                  variant="outlined"
                  margin="normal"
                  color="#E9540D"
                  required
                  fullWidth
                  type={showRepeatNewPassword ? 'text' : 'password'}
                  name="repeatpassword"
                  label="Repetir Nueva Contraseña"
                  id="repeatpassword"
                  disabled={loader}
                  onChange={e => setRepeatNewPassword(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockOutlinedIcon className={classes.iconmail} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle repeat password visibility"
                          onClick={handleClickShowRepeatNewPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          className={classes.visibilityButton}
                        >
                          {showRepeatNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )

                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.inputLabel,
                      focused: classes.inputLabelFocused,
                    }
                  }}
                  helperText={emptyRepeatNewPassword ? "Campo vacio" : !equalsPassword ? "Las contraseñas no coinciden" : ""}
                />

                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  disabled={loader}
                  onClick={(event) => handleClickNewPassword(event)}
                >
                  {loader && <CircularProgress size={24} className={classes.buttonProgress} />}
                  Conectar
                </Button>

                <Box mt={5}>
                  <Copyright />
                </Box>
              </form>

            }
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}